import { CSSProperties, FunctionComponent } from 'react'

import { ColumnFiltersState, PaginationState, SortingState } from '@tanstack/table-core'

import { ButtonVariant } from '@/atoms/button'

export enum Direction {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum TableType {
  DEFAULT = 'DEFAULT',
  CARD = 'CARD',
}

export enum RowHeight {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  AUTO = 'auto',
}

export enum TableFilter {
  TEXT = 'TEXT',
  MIN_MAX = 'MIN_MAX',
  DATE_RANGE = 'DATE_RANGE',
  SELECT = 'SELECT',
  MULTI_SELECT = 'MULTI_SELECT',
}

export interface Filter {
  id: string
  value: string
}

export interface SortBy {
  id: string
  desc?: boolean
}

export interface FetchDataProps {
  pageSize?: number
  pageIndex?: number
  sortBy?: Array<SortBy>
  filters?: Array<Filter>
  rowHeight?: RowHeight
  expanded?: { [key: string]: boolean }
}

export interface FetchTableDataProps {
  pagination: PaginationState
  sorting: SortingState
  columnFilters: ColumnFiltersState
}

export enum TotalType {
  GROUP_TOTAL = 'GroupTotal',
  GRAND_TOTAL = 'GrandTotal',
}

export interface ActionBarButton {
  id: string
  title: string
  variant?: ButtonVariant
  onClick?: () => void
  loading?: boolean
  disabled?: boolean
  hide?: boolean
}

export interface ActionBarForm<T extends object> {
  id: string
  title?: string
  description?: string
  component: FunctionComponent<T>
  componentProps?: T
}

export interface ActionBarProps<A extends object> {
  buttons: Array<ActionBarButton>
  forms?: Array<ActionBarForm<A>>
}

export interface RowHeightTableState {
  rowHeight: RowHeight
}

export interface RowHeightOptions {
  enableRowHeightResize?: boolean
}

export interface CustomTableStyles {
  table?: () => { style?: CSSProperties }
  bodyRow?: (row) => { style?: CSSProperties }
  rowHeight?: (row, rowHeight: RowHeight) => RowHeight
  cell?: (cell, index) => { style?: CSSProperties }
  headerCell?: (header) => { style?: CSSProperties }
}
